import * as React from 'react';
import Icon from '../../widgets/Icons';
import ScorePanel from '../../widgets/ScorePanel';
import ScoreBar from '../../widgets/ScoreBar';
import { DEFAULT_SECURITY_SCORE, ROUTE_PATH } from '../../constants';
import { Link } from 'react-router-dom';

// Security Readiness
type Props = {
  score: number | null;
};

export const NumericSecurityScore = (props: Props) => {
  let { score } = props;

  return (
    <Link
      to={ROUTE_PATH.DASHBOARD.COVERAGE_SCORE}
      className="clickable-dashboard-item"
      data-cy="coverage-score"
    >
      <ScorePanel
        className="hover-shadow"
        title="Coverage Score"
        icon={<Icon.Bookmark />}
        score={
          <div className="score-bar">
            <h1>{score ? `${score}%` : DEFAULT_SECURITY_SCORE}</h1>
          </div>
        }
      >
        <ScoreBar value={score || 0} />
        <div className="text-center">
          <span className="btn-link">Click here</span>
          {` `}
          for more details.
        </div>
      </ScorePanel>
    </Link>
  );
};
